import { motion } from 'framer-motion';

const CertificationsSection = () => {
  const certifications = [
    {
      name: 'Gas Safe Registered',
      icon: 'ri-shield-check-fill',
      color: 'text-red-600',
    },
    {
      name: 'Part P Certified',
      icon: 'ri-flashlight-fill',
      color: 'text-yellow-600',
    },
    {
      name: 'Public Liability Insurance',
      icon: 'ri-shield-user-fill',
      color: 'text-blue-600',
    },
    {
      name: 'Checkatrade Approved',
      icon: 'ri-star-fill',
      color: 'text-green-600',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2F4A] mb-4">
            Fully Qualified & Insured
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            We maintain all necessary certifications and insurance to provide you with complete peace of mind
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {certifications.map((cert, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-[#F7F9FB] rounded-2xl p-8 text-center hover:shadow-lg transition-shadow"
            >
              <div className={`w-16 h-16 flex items-center justify-center mx-auto mb-4 ${cert.color}`}>
                <i className={`${cert.icon} text-5xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-[#1A2F4A]">{cert.name}</h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CertificationsSection;